import Vue from 'vue'

function setErrorClassToForm(errorKeys) {
  if (errorKeys.length > 0) {
    errorKeys.map((v) => {
      const nodeList = document.querySelectorAll('input[name=' + v + '],textarea[name=' + v + '],select[name=' + v + ']')
      if (nodeList) {
        for (let form of nodeList) {
          form.classList.add("error")
        }
      }
    })
  }
}

function scrollToFirstError() {
  const el = document.querySelector('.error')
  if (el) {
    el.scrollIntoView()
  }
}

export default (data) => {

  const vm = new Vue({
    el: '#form_container',
    data: data,
    methods: {
      contractor_add: function () {
        if (data.form.other1_contractor == '') {
          data.form.other1_contractor = true;
        }
        else if (data.form.other2_contractor== '') {
          data.form.other2_contractor = true;
        }
        return true;
      },
      contractor_del: function () {
        if (data.form.other2_contractor == true || data.form.other2_contractor == 'true') {
          data.form.other2_contractor = '';
        }
        else if (data.form.other1_contractor == true || data.form.other1_contractor == 'true') {
          data.form.other1_contractor = '';
        }
        return true;
      },
      upload_front: function (event) {
        let file = event.target.files[0];
        if(!this.is_valid_file(file)) {
          event.target.value = '';
          data.certificate_front.flg = false;
          data.certificate_front.file_name = '';
          data.form.image_front_name = '';
          data.form.image_front_upload = '';
          return false;
        }
        data.certificate_front.flg = true;
        data.certificate_front.file_name = file.name;
        return true;
      },
      upload_back: function (event) {
        let file = event.target.files[0];
        if(!this.is_valid_file(file)) {
          event.target.value = '';
          data.certificate_back.flg = false;
          data.certificate_back.file_name = '';
          data.form.image_back_name = '';
          data.form.image_back_upload = '';
          return false;
        }
        data.certificate_back.flg = true;
        data.certificate_back.file_name = event.target.files[0].name;
        return true;
      },
      upload_car: function (event) {
        let file = event.target.files[0];
        if(!this.is_valid_file(file)) {
          event.target.value = '';
          data.certificate_car.flg = false;
          data.certificate_car.file_name = '';
          data.form.image_car_name = '';
          data.form.image_car_upload = '';
          return false;
        }
        data.certificate_car.flg = true;
        data.certificate_car.file_name = event.target.files[0].name;
        return true;
      },
      is_valid_file: function (file) {
        if (file.size > (1024 * 1024 * 10)) {
          alert('画像サイズが10MBを超えています。\n10MB以下のファイルをアップロードしてください。');
          return false;
        }
        if (!/^image\/jpeg/.test(file.type)
        &&  !/^image\/png/.test(file.type)
        &&  !/^image\/gif/.test(file.type)
        &&  !/^application\/pdf/.test(file.type) ) {
          alert('画像又はPDFのみアップロードできます');
          return false;
        }
        return true;
      }
    },
    watch: {
      'form.zip': function (zip) {
        let _this = this;
        if (8 != zip.length) {
          return;
        }
        new window.YubinBango.Core(zip, function (addr) {
          _this.form.pref = addr.region_id // 都道府県ID
          _this.form.address1 = addr.locality + addr.street // 市区町村
        })
      },
      'form.target_address_zip': function (zip) {
        let _this = this;
        if (8 != zip.length) {
          return;
        }
        new window.YubinBango.Core(zip, function (addr) {
          _this.form.target_address_pref = addr.region_id // 都道府県ID
          _this.form.target_address_address1 = addr.locality + addr.street // 市区町村
        })
      }
    },
    computed: {
      fee: function () {
      }
    },
    mounted: function () {
      setErrorClassToForm(this.errors)
      scrollToFirstError()
    }
  })
}
